import styled, { css } from "styled-components";

export const SeoContentItemWrapper = styled.li`
  margin: 0px;
  padding: 0px;
  list-style: none;
  border-top: none;
  padding-bottom: var(--spacingS);

  @media screen and (min-width: 1128px) {
    border-top: 1px solid var(--gray200);
    padding-top: var(--spacingL);
    padding-bottom: var(--spacingL);
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--gray200);
  border-radius: var(--radiusXs);
  padding: var(--spacingS);

  > h3 {
    color: var(--primary800);
    font-size: var(--textM);
    line-height: var(--lineHeightM);
    margin-right: 5px;
  }

  > svg {
    min-height: 20px;
    min-width: 20px;
  }

  @media screen and (min-width: 1128px) {
    border: none;
    padding: 0px;

    > h3 {
      width: 100%;
      height: 100%;
      margin: 0;
    }

    > svg {
      display: none;
    }
  }
`;

export const Description = styled.div`
  font-size: var(--textS);
  line-height: var(--lineHeightS);
  white-space: break-spaces;
  display: none;
  padding: var(--spacingXs) var(--spacingM);
  gap: var(--spacingXs);
  transition: display 5s ease-in;

  > p {
    margin: 0px;
    word-break: break-word;
  }

  @media screen and (min-width: 1128px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-gap: var(--spacingXl);
    width: 100%;
    white-space: pre-wrap;
    line-height: var(--lineHeightXs);
    height: auto;
    margin-bottom: 0px;
    padding: 0px;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;

  ${Description}{
    ${({ isOpen }) =>
      isOpen &&
      css`
        display: flex;
        flex-direction: column;
        height: auto;
      `}
  }

  @media screen and (min-width: 1128px) {
    grid-template-columns: 3fr 9fr;
    grid-template-rows: auto;
    grid-gap: var(--spacingXl);

    ${Description}{
      ${({ isOpen }) =>
        isOpen &&
        css`
          display: grid;
          height: auto;
        `}
    }
}
  }
`;

export default SeoContentItemWrapper;
